module.exports = __webpack_public_path__ + "img/golfouritLogo2.72332b53.png";